import 'rc-time-picker/assets/index.css';
import { css } from 'emotion';
import { injectGlobal } from 'react-emotion';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';
import TimePicker from 'rc-time-picker';

import Style from '../../../../styles/common';

const textStyles = css`
  font-size: ${Style.FONT_SIZE.M};
  font-weight: ${Style.FONT_WEIGHT.LIGHT};
`;

const Container = styled('div')`  
  .rc-time-picker-input {
    ${textStyles};
    border-radius: ${Style.BORDER_RADIUS};
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    margin-top: -3px; // rc-time-picker popup alignment hack
    outline: none;
    padding: 32px;
    width: 170px;
  
    ::placeholder {
      color: ${Style.color.PLACEHOLDER};
    }
  }
`;

injectGlobal`
  .rc-time-picker-panel-clear-btn {
    display: none;
  }
  
  .rc-time-picker-panel-inner {
    background-color: transparent;
    border: 0;
    border-top-left-radius: 0;
    box-shadow: none;
  }

  .rc-time-picker-panel-input-wrap {
    border: 0;
    border-left: 1px solid transparent;
    padding: 20px 31px;
  }
  
  .rc-time-picker-panel-combobox {
    background-color: white;
    border: 1px solid ${Style.color.INPUT.BORDER};
    border-radius: ${Style.BORDER_RADIUS};
    box-shadow: ${Style.INPUT_MODAL_BOX_SHADOW};
    height: 180px;
    margin-top: ${Style.MEASUREMENT.INPUT.MODAL_OFFSET};
    overflow: hidden;
  }
  
  .rc-time-picker-panel-input {
    ${textStyles};
  }
  
  .rc-time-picker-panel-select {
    max-height: 180px;
    
    &:last-child {
      width: 58px;
    }

    li {
      font-size: 14px;
      height: auto;
      padding-bottom: 8px;
      padding-top: 8px;
      
      &:hover {
        background-color: ${Style.color.INPUT.HOVER};
      }
    }

    .rc-time-picker-panel-select-option-selected {
      &,
      &:hover,
      &:active {
        background-color: ${Style.color.INPUT.ACTIVE};
        color: ${Style.color.INPUT.ACTIVE_TEXT};
      }
    }
  }
`;

class TimeInput extends React.Component {
  static propTypes = {
    defaultDate: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
  };

  render() {
    return (
      <Container>
        <TimePicker
          format={'h:mm a'}
          defaultOpenValue={this.props.defaultDate}
          minuteStep={5}
          onChange={this.onTimeChange}
          onClose={this.onClose}
          onOpen={this.onOpen}
          placeholder="Time"
          showSecond={false}
          use12Hours
          value={this.props.input.value}
        />
      </Container>
    );
  }

  onTimeChange = value => {
    const stateValue = this.props.input.value ?
      this.props.input.value.clone() : this.props.defaultDate;
    this.props.input.onChange(
      stateValue.set({
        hour: value.hour(),
        minute: value.minute(),
        second: 0,
        millisecond: 0,
      }),
    );
  };

  onClose = () => this.props.input.onBlur();
  onOpen = () => this.props.input.onFocus();
}

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components/Form/DateTimeInput/TimeInput/TimeInput.js